import { createSelector } from 'reselect';

const constructionSelector = (state) => state.Construction;

export default createSelector(
  constructionSelector,
  (construction) => ({
    available: [...construction.available.bolt],
    info: construction.info.bolt,
    loaded: construction.parameters_loaded,
    selected: construction.selected.bolt
  })
);
